{
  "components": {
    "comments": {
      "commentCard": {
        "campComment": "Tout le camp",
        "deleteDisabledReplies": "Les commentaires avec des réponses d'autres personnes ne peuvent pas être supprimés.",
        "deleteWarning": "Veux-tu vraiment supprimer ton commentaire ?",
        "deleteWithRepliesWarning": "Veux-tu vraiment supprimer ton commentaire et ses réponses ?",
        "deleted": "(supprimé)",
        "deletedAuthor": "Personne supprimée"
      },
      "commentComposer": { "placeholder": "Écrire un commentaire", "replyPlaceholder": "Écrire une réponse" },
      "commentThread": {
        "reopen": "Rouvrir",
        "reply": "Répondre",
        "resolve": "Résoudre",
        "resolved": "Résolu",
        "resolvedBy": "Résolu par {user}",
        "resolvedToast": "Commentaire résolu. Les commentaires résolus sont uniquement affichés sous « Tous ».",
        "showAll": "Tout afficher"
      },
      "commentTime": { "today": "Aujourd’hui, {time}", "yesterday": "Hier, {time}" },
      "commentsList": {
        "empty": "Aucun commentaire pour le moment.",
        "noOpenComments": "Aucun commentaire ouvert. Passe à « Tous » pour voir les commentaires résolus."
      },
      "commentsPanel": {
        "activityCommentsElsewhere": "Un autre commentaire ouvert concerne une activité. | {count} autres commentaires ouverts concernent des activités.",
        "all": "Tous",
        "commentsOnThisActivity": "Commentaires sur cette activité",
        "open": "Ouverts",
        "title": "Commentaires"
      },
      "commentsToggleButton": {
        "hide": "Masquer les commentaires",
        "show": "Afficher les commentaires | Afficher un commentaire | Afficher {count} commentaires"
      }
    },
    "activity": {
      "content": {
        "checklist": {
          "title": "Modifier la check-list"
        },
        "columnLayout": {
          "columnOperations": {
            "addColumn": "Ajouter une colonne",
            "removeColumn": "Supprimer la colonne vide"
          }
        },
        "lAThematicArea": {
          "placeholder": "Choisir un domaine thématique"
        },
        "storyboard": {
          "controls": "Actions",
          "reorder": "Déplacer",
          "storyboardDialogRemoveSection": {
            "deleteWarning": "Veux-tu vraiment supprimer cette ligne ?",
            "title": "Confirmer la suppression ?"
          }
        },
        "ysActivityCharacteristics": {
          "placeholder": "Sélectionner les formes caractéristiques"
        }
      },
      "dialog": {
        "dialogActivityEdit": {
          "title": "Modifier l'activité"
        },
        "formScheduleEntryList": {
          "name": "Dates planifiées"
        }
      },
      "menuCardlessContentNode": {
        "deletingDisabled": "Doit être vide pour être supprimé"
      },
      "scheduleEntry": {
        "backToContents": "Retour à l'édition du contenu",
        "changeLayout": "Changer la mise en page",
        "clipboardInfoDialog": {
          "allow": "Autoriser maintenant",
          "denied": "Vous avez refusé l'accès à votre presse-papiers. Par conséquent, vous ne pouvez pas coller les activités copiées.",
          "description": "Pour coller une activité copiée, vous devez autoriser eCamp v3 à lire votre presse-papiers.",
          "granted": "Vous pouvez maintenant coller les activités copiées.",
          "title": "Copier et coller une activité"
        },
        "copyScheduleEntry": "Copier une activité",
        "deleteWarning": "Veux-tu vraiment supprimer cette activité ? Tout le contenu de cette activité sera supprimé."
      },
      "togglePaperSize": {
        "switchToFullSize": "Passer au format large",
        "switchToPaperSize": "Passer au format papier"
      }
    },
    "camp": {
      "campInvitations": {
        "title": "Inviter"
      },
      "campListItem": {
        "public": "publique"
      },
      "campMembers": {
        "title": "Membres"
      },
      "footerSharedCamp": {
        "outsider": "Tu ne travailles pas dans ce camp :",
        "outsiderDescription": "Tu ne peux pas modifier les données, mais tu peux consulter et copier le programme.",
        "shared": "Le camp est ouvert au public :",
        "sharedDescription": "Des personnes étrangères peuvent consulter et copier toutes les données du camp."
      }
    },
    "campAdmin": {
      "campActivityProgressLabels": {
        "create": "Créer un statut",
        "deleteError": "Le statut ne peut pas être supprimé. Il est toujours utilisé.",
        "deleteWarning": "Veux-tu vraiment supprimer ce statut?",
        "exit": "Fin du réagencement",
        "moveDown": "Descendre",
        "moveUp": "Monter",
        "reorder": "Réordonner",
        "title": "Statut des activités"
      },
      "campAddress": {
        "title": "Adresse"
      },
      "campCategories": {
        "create": "Créer une catégorie d'activité",
        "pasteCategory": "Coller la catégorie",
        "title": "Catégories d'activités"
      },
      "campConditionalFields": {
        "course": {
          "title": "Cours"
        },
        "title": "Paramètres pour J+S",
        "ysCamp": {
          "title": "Camps"
        }
      },
      "campDangerZone": {
        "deleteCamp": {
          "description": "Une fois un camp supprimé, il est impossible de revenir en arrière. Ne continue que si tu es sûr.",
          "explanation": "Cette action ne peut pas être annulée. Cette action supprimera définitivement le camp \"{campTitle}\", les activités, les listes de matériel et les personnes ajoutées.",
          "label": "Veuillez saisir \"{campTitle}\" pour confirmer.",
          "title": "Supprimer le camp"
        },
        "title": "Zone à risque"
      },
      "campHitobitoSync": {
        "linked": "Ce camp est lié à {provider}.",
        "sync": "Synchroniser",
        "title": "Synchroniser les infos du camp"
      },
      "campMaterialLists": {
        "createMaterialList": "Créer une liste de matériel",
        "title": "Listes de matériel"
      },
      "campPeriods": {
        "createPeriod": "Créer une période",
        "title": "Période | Périodes"
      },
      "campPeriodsListItem": {
        "changePeriodDescription": "Modifier la description",
        "deleteWarning": "Veux-tu vraiment supprimer cette période ?",
        "lastPeriodNotDeletable": "La dernière période ne peut pas être supprimée",
        "movePeriod": "Déplacer la période",
        "periodChangeEnd": "Ajouter/supprimer des jours à la fin",
        "periodChangeStart": "Ajouter/supprimer des jours au début"
      },
      "campSettings": {
        "title": "Paramètres"
      },
      "campSharingSettings": {
        "activate": "Activer le partage",
        "deactivate": "Désactiver le partage",
        "implications": "Si tu actives le partage, les personnes extérieures peuvent consulter et copier le programme, la liste des participants, les listes de matériel, les responsabilités et tout autre élément relatif à ce camp. Seules les personnes faisant partie de l'équipe peuvent modifier les données.",
        "notShared": {
          "description": " : Seules les personnes faisant partie de l'équipe peuvent consulter le programme et les données relatives à ce camp.",
          "title": "L'autorisation n'est pas activée"
        },
        "publicCampUrl": "Lien publique du camp",
        "shared": {
          "description": " : Les personnes extérieures peuvent consulter et copier le programme, la liste des participants, la liste du matériel, les responsabilités et tout autre élément relatif à ce camp. Seules les personnes faisant partie de l'équipe peuvent modifier les données.",
          "title": "le camp est ouvert au public"
        },
        "sharedSince": "Le {sharedSince} par {sharedBy}",
        "title": "Partager le camp"
      },
      "createCampPeriods": {
        "add": "Ajouter une période"
      },
      "dialogActivityProgressLabelCreate": {
        "title": "Créer un statut"
      },
      "dialogActivityProgressLabelEdit": {
        "title": "Modifier le statut"
      },
      "dialogCategoryCreate": {
        "clearClipboard": "Vider le presse-papiers",
        "clipboard": "Presse-papiers",
        "clipboardInfoDialog": {
          "allow": "Autoriser maintenant",
          "denied": "Tu as refusé l'accès à ton presse-papiers. Par conséquent, tu ne peux pas coller les catégories copiées.",
          "description": "Pour coller une catégorie copiée, vous devez autoriser eCamp v3 à lire votre presse-papiers.",
          "granted": "Tu peux maintenant coller les catégories copiées.",
          "title": "Copier et coller la catégorie"
        },
        "copyCategoryOrActivity": "Copier la catégorie ou l'activité",
        "copyContent": "Copier le contenu",
        "copyPasteCategory": "Copier et coller la catégorie",
        "copySourceInfo": "Tu peux coller ici l'URL d'une catégorie ou d'une activité pour copier son contenu.",
        "pasteCategory": "Copier la catégorie ou l'activité",
        "title": "Créer une catégorie d'activité"
      },
      "dialogMaterialListCreate": {
        "title": "Créer une liste de matériel"
      },
      "dialogMaterialListEdit": {
        "deleteError": "Impossible de supprimer la liste de matériel. Vérifie que la liste soit vide avant de la supprimer.",
        "title": "Modifier la liste de matériel"
      },
      "dialogPeriodCreate": {
        "title": "Créer une période"
      },
      "dialogPeriodDateEdit": {
        "movePeriod": "Déplacer la période",
        "periodChangeEnd": "Ajouter / supprimer des jours à la fin de cette période",
        "periodChangeStart": "Ajouter / supprimer des jours au début de cette période",
        "periodDuration": "Nombre de jours"
      },
      "dialogPeriodEdit": {
        "moveScheduleEntries": "Déplacer les entrées du calendrier"
      },
      "errorExistingActivitiesList": {
        "description": "Ne peut pas être supprimé. Toujours utilisé par les activités suivantes :"
      }
    },
    "campCreate": {
      "campCreate": {
        "steps": {
          "configurate": "Configuration",
          "infos": "Info",
          "template": "Modèle"
        }
      },
      "campCreateStep1": {
        "submitTooltip": "Remplis tous les champs obligatoires.",
        "titlePlaceholder": "Camp d'été 2024"
      },
      "campCreateStep2": {
        "category": "Catégories d'activités",
        "checklistItemCount": "Aucune entrée | Une entrée | {count} entrées",
        "checklists": "Check-lists",
        "clipboardInfoDialog": {
          "allow": "Autoriser maintenant",
          "denied": "Tu as refusé l'accès à ton presse-papiers. Par conséquent, tu dois entrer le lien vers le modèle de camp manuellement.",
          "description": "Pour coller les paramètres d'un camp copié, tu dois autoriser eCamp v3 à lire ton presse-papiers.",
          "granted": "Tu peux maintenant coller les paramètres de camp copiés.",
          "title": "Copier et coller les paramètres du camp"
        },
        "create": "Créer le camp",
        "materialLists": "Listes de matériel",
        "noContent": "Pas de contenu",
        "noPrototype": "Pas de modèle",
        "noPrototypeAlert": {
          "description": "Tu dois effectuer tous les réglages manuellement. Il n'y a pas de modèles de blocs ni de mises en page. Ceci ne convient qu'aux utilisateurs expérimentés.",
          "title": "Attention : Vous avez choisi \"Pas de modèle\"."
        },
        "otherPrototype": "Copier les paramètres d'un autre camp…",
        "pasteCamp": "Coller les paramètres du camp copié",
        "preview": "Aperçu du modèle du camp",
        "progressLabels": "États d'activités",
        "prototypeCampUrl": "Lien du modèle de camp désiré",
        "prototypeHint": "Copie les catégories, les modèles de blocs et les états de blocs d'un modèle de camp.",
        "prototypeHintEmpty": "Ne pas copier de catégories, de modèles de blocs et de statuts de blocs à partir d'un modèle de camp.",
        "prototypeHintOther": "Copier les catégories, les modèles d'activités, les statuts, les listes de documents non personnels et les check-lists de cet autre camp. Aucune activité n'est copiée.",
        "prototypeHintSelected": "Copie les catégories, les modèles de blocs et les statuts de blocs de ce modèle de camp.",
        "submitTooltipPrototype": "Tu dois encore choisir si tu veux utiliser un modèle de champ et lequel."
      }
    },
    "campHitobitoSync": {
      "hitobitoSyncDiffTable": {
        "current": "Actuel (eCamp)",
        "field": "Champ",
        "updated": "Nouveau ({provider})"
      }
    },
    "campImport": {
      "campImport": {
        "steps": {
          "event": "Camp",
          "template": "Modèle"
        }
      },
      "campImportStep1": {
        "alreadyImported": "Déjà importé",
        "event": "Camp",
        "noEvents": "Aucun camp trouvé",
        "search": "Rechercher un camp",
        "submitTooltip": "Sélectionne un camp."
      },
      "errors": {
        "alreadyExists": "Un camp eCamp existe déjà pour ce camp {provider}.",
        "generic": "Les camps n'ont pas pu être chargés. Réessaie plus tard.",
        "noAccess": "Tu n'as pas accès à ce camp.",
        "notFound": "Ce camp n'a pas été trouvé."
      },
      "hitobitoEventSummary": {
        "field": "Champ",
        "fields": {
          "address": "Adresse",
          "end": "Fin",
          "motto": "Thème",
          "start": "Début",
          "title": "Titre"
        },
        "period": "Période {number}",
        "title": "Infos sur le camp",
        "value": "Valeur"
      }
    },
    "category": {
      "categoryTemplate": {
        "contents": "Contenus",
        "createLayoutHelp": "Ici, vous pouvez définir le modèle pour de nouvelles activités {categoryShort}.{br}Le contenu et la mise en page des activités {categoryShort} déjà créées ne seront pas ajustés.",
        "layout": "Layout",
        "noTemplate": "Pas de modèle"
      }
    },
    "checklist": {
      "checklistCreate": {
        "title": "Créer une check-list"
      },
      "checklistDetail": {
        "deleteError": "La check-list n'a pas pu être supprimée. Assure-toi que la check-list n'est pas utilisée dans les activités avant d'essayer de la supprimer.",
        "deleteWarning": "Veux-tu vraiment supprimer cette check-list ? Tout le contenu de cette check-list sera supprimé."
      },
      "checklistItemCreate": {
        "add": "Créer un point de check-list",
        "title": "Ajouter un point de check-list"
      },
      "checklistItemEdit": {
        "delete": "Veux-tu vraiment supprimer cet élément ?",
        "title": "Modifier le point de check-list"
      },
      "sortableChecklist": {
        "add": "Ajouter à \"{parent}\""
      }
    },
    "collaborator": {
      "collaboratorBulkCreate": {
        "validationFailed": "Déjà dans le camp ou e-mail invalide:",
        "emailsHint": "Entrer une adresse e-mail par ligne ou séparées par des virgules",
        "emailsLabel": "Adresses e-mail",
        "failedEmails": "Échec de l'invitation: {emails}",
        "invite": "Envoyer les invitations",
        "inviteCta": "Inviter plusieurs personnes",
        "successCount": "{count} invitation(s) envoyée(s)",
        "title": "Inviter plusieurs personnes"
      },
      "collaboratorCreate": {
        "invite": "Envoyer l'invitation",
        "inviteCta": "Inviter",
        "title": "Inviter une personne"
      },
      "collaboratorEdit": {
        "cannotRemoveLastManager": "Tu ne peux pas supprimer le dernier manager.",
        "deactivate": "Désactiver",
        "delete": "Veux-tu vraiment supprimer la personne '{name}' ?",
        "inviteAgain": "Inviter de nouveau",
        "leaveCamp": "Quitter le camp",
        "resendEmail": "Renvoyer l'email",
        "resentEmail": "Invitation envoyée",
        "title": "Modifier {user}"
      },
      "collaboratorForm": {
        "overrideAvatar": "Remplacer l'avatar pour ce camp",
        "roleHint": "Chaque camp nécessite au moins une personne disposant de droits d'administrateur."
      },
      "collaboratorHitobitoInvite": {
        "inviteCta": "Inviter depuis {provider}"
      },
      "promptCollaboratorDeactivate": {
        "deactivate": "Désactiver",
        "leaveCamp": "Quitter le camp",
        "warningText": "Veux-tu désactiver '{name}' ?",
        "warningTextLeaveCamp": "Voulez-vous sortir du camp \"{camp}\" ?"
      }
    },
    "dashboard": {
      "selectFilter": {
        "clear": "Vider"
      }
    },
    "dialog": {
      "dialogEntityDelete": {
        "title": "Confirmation de suppression"
      }
    },
    "form": {
      "base": {
        "eColorField": {
          "parseError": "Merci de saisir une couleur valide."
        },
        "eColorPicker": {
          "closePicker": "Fermer le dialogue",
          "openPicker": "Ouvre un dialogue pour sélectionner une couleur pour {label}"
        },
        "eDatePicker": {
          "invalidFormat": "Format non valide, veuillez saisir la date au format MM/JJ/AAAA.",
          "openPicker": "Ouvre un dialogue pour sélectionner une date pour {label}"
        },
        "eTimeField": {
          "invalidFormat": "Format non valide, veuillez saisir l'heure au format HH:MM AM/PM"
        },
        "eTimePicker": {
          "invalidFormat": "Format non valide, veuillez saisir l'heure au format HH:MM AM/PM",
          "openPicker": "Ouvre un dialogue pour sélectionner une heure pour {label}"
        }
      }
    },
    "generic": {
      "lockButton": {
        "clickToLock": "Cliquer pour verrouiller",
        "clickToUnlock": "Cliquer pour déverrouiller",
        "guestsCannotEdit": "Les invités n'ont pas le droit de modifier"
      }
    },
    "layout": {
      "authContainer": {
        "photoCredits": "Photo par Markus Rohner / Lotos"
      }
    },
    "material": {
      "dialogMaterialItemCreate": {
        "title": "Ajouter du matériel"
      },
      "dialogMaterialItemEdit": {
        "title": "Modifier l'entrée de matériel"
      },
      "materialCreateItem": {
        "campSettingsButton": "Paramètres",
        "noMaterialListAvailable": "Il n'y a pas encore de liste de matériel pour ce camp. Tu peux les créer dans 'Admin'."
      },
      "materialLists": {
        "materialsCount": "Pas des éléments | Un élément | {count} éléments",
        "overview": "Aperçu général",
        "unassigned": "Pas assigné"
      },
      "materialTable": {
        "addNewItem": "Ajoute un nouvel élément",
        "noItems": "Aucun élément matériel trouvé",
        "periodOnly": "Filtre : Période",
        "reference": "Activité / Période"
      },
      "useMaterialViewHelper": {
        "detail": "Liste de matériel",
        "overview": "Aperçu général"
      }
    },
    "navigation": {
      "userMeta": {
        "admin": "Admin",
        "invitations": "Invitations",
        "logOut": "Se déconnecter",
        "myCamps": "Mes camps",
        "profile": "Profil"
      }
    },
    "personalInvitations": {
      "dialogPersonalInvitationReject": {
        "rejectInvitation": "Refuser l'invitation",
        "warningText": "Tu veux vraiment refuser l'invitation au camp \"{campTitle}\" ?"
      },
      "personalInvitations": {
        "accept": "Accepter",
        "noOpenInvitations": "Aucune invitation ouverte. L'invitation a-t-elle été envoyée à une autre adresse que \"{email}\" ?",
        "reject": "Refuser"
      }
    },
    "print": {
      "config": {
        "activityConfig": {
          "activity": "Activité"
        },
        "dialogScheduleEntryFilter": {
          "filterActive": "Filtre: {filtered} activités sur {total}",
          "filterActivities": "Filtre: {total} activités",
          "resultCount": "Résultat: {filtered} des activités sur {total}",
          "title": "Filtrer les activités"
        },
        "picassoConfig": {
          "orientation": "Mise en page",
          "landscape": "Paysage",
          "periods": "Période(s) du camp",
          "portrait": "Portrait"
        },
        "programConfig": {
          "dayOverview": "Aperçu des jours"
        }
      },
      "documents": {
        "campPrint": {
          "filename": {
            "activitiesOnly": "Activités {camp}",
            "picassoOnly": "Programme général {camp}"
          }
        }
      },
      "localPdfDownloadButton": {
        "error": "Une erreur est survenue. Essaie à nouveau, ou recharge la page."
      },
      "printClient": {
        "downloadClientPdfButton": {
          "label": "Télécharger le PDF (mise en page #2)"
        },
        "downloadClientPdfListItem": {
          "label": "Télécharger le PDF (mise en page #2)"
        },
        "generatePdfMixin": {
          "error": "Une erreur est survenue. Essaie à nouveau, ou recharge la page.",
          "progress": {
            "loadingData": "Chargement des dernières données du camp…",
            "setupTranslationsAndFonts": "Chargement des polices et des textes statiques…",
            "assembleContent": "Assemblage {type} ({content} sur {totalContents})…",
            "layoutDocument": "Calcul de la mise en page du document…",
            "layoutPage": "Calcul de la mise en page de la page {page}…",
            "renderingPdfPage": "Rendu du pdf, page {page} sur {totalPages}…",
            "downloadingPdf": "Téléchargement du pdf en cours…",
            "done": "Terminé",
            "failed": "Echec"
          }
        },
        "printPreviewClient": {
          "previewError": "Une erreur est survenue. Veuillez réessayer avec des paramètres d'impression différents, ou recharger la page.",
          "previewIframeTitle": "Aperçu avant impression"
        }
      },
      "printConfigurator": {
        "add": "Ajouter du contenu",
        "config": {
          "Activity": "Activité unique",
          "ActivityList": "Liste des blocs (cours)",
          "Cover": "Page de couverture",
          "Picasso": "Picasso",
          "Program": "Programme",
          "SafetyConsiderations": "Considérations sur la sécurité",
          "Story": "Histoire",
          "Toc": "Table des matières"
        },
        "options": "Paramètres",
        "pageNumbers": "Numéros de page"
      },
      "printNuxt": {
        "downloadNuxtPdfButton": {
          "label": "Télécharger le PDF (mise en page #1)"
        },
        "downloadNuxtPdfListItem": {
          "label": "Télécharger le PDF (mise en page #1)"
        },
        "generatePdfMixin": {
          "error": "Une erreur est survenue. Essaie à nouveau, ou recharge la page.",
          "queueFull": "Toutes nos imprimantes PDF sont occupées en ce moment. Veuillez réessayer plus tard."
        },
        "printPreviewNuxt": {
          "openPreview": "Ouvrir l'aperçu dans une nouvelle fenêtre",
          "previewError": "Une erreur est survenue. Veuillez réessayer avec des paramètres d'impression différents, ou recharger la page.",
          "previewIframeTitle": "Aperçu avant impression"
        }
      }
    },
    "program": {
      "dialogActivityCreate": {
        "clearClipboard": "Vider le presse-papier",
        "clipboard": "Presse-papier",
        "clipboardInfoDialog": {
          "allow": "Autoriser maintenant",
          "denied": "Vous avez refusé l'accès à votre presse-papiers. Par conséquent, vous ne pouvez pas coller les activités copiées.",
          "description": "Pour coller une activité copiée, vous devez autoriser eCamp v3 à lire votre presse-papiers.",
          "granted": "Vous pouvez maintenant coller les activités copiées.",
          "title": "Copier et coller une activité"
        },
        "copyActivity": "Copier une activité",
        "copyActivityContent": "Copier le contenu depuis une activité",
        "copyPasteActivity": "Copier et coller une activité",
        "copySourceInfo": "Vous pouvez coller ici l'URL d'une activité pour copier son contenu.",
        "pasteActivity": "coller l'activité"
      },
      "formScheduleEntryItem": {
        "end": "Fin",
        "start": "Début"
      },
      "formScheduleEntryList": {
        "name": "Dates planifiées"
      },
      "periodSwitcher": {
        "title": "Choisir la période"
      },
      "picasso": {
        "picasso": {
          "datetime": {
            "fullDate": "dd DD. MMMM YYYY",
            "smallDate": "dd D.MM. | dd D. MMM | dd D. MMM YY"
          }
        },
        "picassoEntry": {
          "clipboardInfoDialog": {
            "allow": "Autoriser maintenant",
            "denied": "Vous avez refusé l'accès à votre presse-papiers. Par conséquent, vous ne pouvez pas coller les activités copiées.",
            "description": "Pour coller une activité copiée, vous devez autoriser eCamp v3 à lire votre presse-papiers.",
            "granted": "Vous pouvez maintenant coller les activités copiées.",
            "title": "Copier et coller une activité"
          },
          "location": "Lieu:",
          "responsible": "Responsable:"
        }
      },
      "scheduleEntryFilters": {
        "category": "Catégorie",
        "clearFilters": "Effacer les filtres",
        "day": "Date",
        "dayLabel": "Jour {dayNumber} ({date})",
        "allMyActivities": "Toutes mes activités",
        "onlyMyActivities": "Seulement mes activités",
        "period": "Période",
        "progressLabel": "Statut",
        "progressLabelNone": "Aucun statut",
        "responsible": "Responsable",
        "responsibleNone": "Aucun responsables"
      }
    },
    "prompt": {
      "promptEntityDelete": {
        "title": "Confirmation de suppression"
      }
    },
    "story": {
      "storyDay": {
        "noStory": "Aucun file rouge trouvé ce jour-là..."
      }
    },
    "toast": {
      "toasts": {
        "multiLineToast": {
          "generalError": "Une erreur est survenue."
        }
      }
    },
    "user": {
      "dialogChangeMail": {
        "error": "Une erreur est survenue.",
        "message": "Un e-mail de vérification sera envoyé.",
        "success": "Ta nouvelle adresse e-mail doit être vérifiée avant de pouvoir être utilisée. Vérifie ta boîte mail.",
        "title": "Changer d'adresse e-mail"
      },
      "dialogChangeMailRunning": {
        "error": "Une erreur est survenue.",
        "message": "Changement d'adresse e-mail ...",
        "success": "L'adresse e-mail a été modifiée avec succès.",
        "title": "Changement d'adresse e-mail"
      },
      "dialogChangePassword": {
        "title": "Changer le mot de passe",
        "currentPassword": "Mot de passe actuel",
        "newPassword": "Nouveau mot de passe",
        "newPasswordConfirmation": "Confirmer le nouveau mot de passe",
        "success": "Votre mot de passe a été modifié avec succès.",
        "error": "Une erreur est survenue."
      }
    }
  },
  "global": {
    "button": {
      "add": "Ajouter",
      "back": "Retour",
      "cancel": "Annuler",
      "change": "Modifier",
      "close": "Fermer",
      "content": "Contenu",
      "continue": "Continuer",
      "copy": "Copier",
      "create": "Créer",
      "delete": "Supprimer",
      "discard": "Rejeter",
      "download": "Télécharger",
      "edit": "Éditer",
      "editable": "Editable",
      "filter": "Filtrer",
      "hidePassword": "Masquer le mot de passe",
      "lock": "Verrouiller",
      "login": "Se connecter",
      "logout": "Déconnexion",
      "move": "Déplacer",
      "ok": "OK",
      "open": "Ouvrir",
      "remove": "Retirer",
      "rename": "Renommer",
      "reset": "Réinitialiser",
      "save": "Sauvegarder",
      "saving": "En cours de sauvegarde",
      "search": "Rechercher",
      "share": "Partager",
      "showPassword": "Afficher le mot de passe",
      "submit": "Envoyer",
      "tryagain": "Réessayer",
      "unlock": "Déverrouiller",
      "update": "Mise à jour"
    },
    "changeLanguage": "Changer de langue",
    "collaborationAbilities": {
      "guest": "Lecture uniquement",
      "manager": "Lecture, écriture & administration du camp",
      "member": "Lecture & écriture"
    },
    "datetime": {
      "vuetifyTimePickerFormat": "24hr"
    },
    "hitobito": {
      "providers": {
        "pbsmidata": "MiData"
      }
    },
    "info": {
      "offline": {
        "description": "Impossible d'enregistrer / de charger des données.",
        "title": "Tu es hors ligne :"
      }
    },
    "language": "Français",
    "loading": "Chargement ...",
    "navigation": {
      "admin": {
        "title": "Admin"
      },
      "help": "Aide",
      "news": "Actualités"
    },
    "newVersion": {
      "title": "Une nouvelle version est disponible",
      "description": "Cette fonctionnalité n’est pas disponible tant que vous n’avez pas installé la dernière version.",
      "update": "Mettre à jour maintenant",
      "updateLater": "Mettre à jour plus tard"
    },
    "selfXssWarning": {
      "title": "Stop !",
      "message": "Cette console du navigateur est destinée aux développeuses et développeurs. Si quelqu'un te demande d'y copier-coller quelque chose, il s'agit presque certainement d'une arnaque : ce que tu colles ici s'exécute en ton nom et peut lire et modifier tous les camps auxquels tu as accès. Ne colle jamais ici du code que tu ne comprends pas entièrement toi-même."
    },
    "serverError": {
      "409": "Oooops... Cette action a provoqué une erreur côté serveur.",
      "short": "erreur de serveur"
    },
    "toast": {
      "copied": "{source} copié"
    },
    "validation": {
      "greaterThan": "{field} doit être supérieur à {min}",
      "greaterThanOrEqual_date": "{field} ne peut pas être antérieure à {min}",
      "greaterThan_time": "{field} doit être postérieure à {min}",
      "lessThanOrEqual_date": "{field} ne peut pas être postérieure à {max}",
      "oneEmojiOrTwoCharacters": "{field} ne peut avoir que 1 emoji ou 2 lettres/chiffres"
    },
    "warning": {
      "delete": "Veux-tu vraiment le supprimer ? | Veux-tu vraiment supprimer \"{entity}\" ?"
    }
  },
  "views": {
    "auth": {
      "activate": {
        "error": "L'activation a échoué",
        "success": "Le compte a été activé avec succès",
        "title": "Ton compte sera activé"
      },
      "login": {
        "acceptTermsOfServiceOnOAuthLogin": "En te connectant via l'un de ces services, tu acceptes les {termsOfServiceLink}.",
        "accountless": "Vous n'avez pas encore de compte?",
        "email": "E-mail",
        "infoText": {
          "dev": "Ceci est la version de développement d'eCamp v3.{br}IMPORTANT : Ceci est destiné à un usage de développement uniquement. Toutes les données sont publiques et seront supprimées périodiquement !{br}Login : test(at)example.com / test"
        },
        "loginCallback": {
          "loginInProgress": "Vous allez être connecté"
        },
        "notActivated": "Pas activité ?",
        "or": "ou avec",
        "password": "Mot de passe",
        "passwordForgotten": "Tu as oublié ton mot de passe ?",
        "provider": {
          "cevidb": "CeviDB",
          "ecamp": "Connectez-vous avec eCamp",
          "google": "Google",
          "jubladb": "Jubla",
          "midata": "MiData"
        },
        "registernow": "Inscrivez-vous maintenant",
        "resendActivation": "Envoyer à nouveau l'e-mail d'activation",
        "resetPassword": "Réinitialiser le mot de passe",
        "termsOfServiceLink": "conditions d'utilisation"
      },
      "register": {
        "acceptTermsOfService": "Accepter les conditions d'utilisation",
        "alreadyHaveAnAccount": "Vous avez déjà un compte ?",
        "passwordConfirmation": "Entrez à nouveau votre mot de passe",
        "register": "S'inscrire",
        "requiredField": "champ obligatoire",
        "title": "Créer un compte"
      },
      "registerDone": {
        "message": "Nous t'avons envoyé un e-mail. Merci de compléter ton inscription en cliquant sur le lien d'activation dans l'email.",
        "success": "Enregistré avec succès",
        "title": "Créer un compte"
      },
      "resendActivation": {
        "errorMessage": "L'envoi de l'e-mail d'activation a échoué à nouveau.",
        "send": "Envoyer",
        "successMessage": "Un e-mail avec le lien pour réinitialiser le mot de passe sera envoyé.",
        "title": "Envoyer à nouveau l'e-mail d'activation"
      },
      "resetPassword": {
        "errorMessage": "La réinitialisation du mot de passe a échoué.",
        "invalidRequest": "Lien invalide",
        "password": "Nouveau mot de passe",
        "passwordConfirmation": "Confirmer le nouveau mot de passe",
        "send": "Set mot de passe",
        "successMessage": "Le nouveau mot de passe a été défini avec succès.",
        "title": "Réinitialiser le mot de passe"
      },
      "resetPasswordRequest": {
        "errorMessage": "La réinitialisation du mot de passe a échoué.",
        "send": "Envoyer",
        "successMessage": "Un e-mail avec le lien pour réinitialiser le mot de passe sera envoyé.",
        "title": "Réinitialiser le mot de passe"
      }
    },
    "camp": {
      "activity": {
        "printPreview": "Ouvrir l'aperçu avant impression",
        "sideBarProgram": {
          "title": "Activités du jour"
        }
      },
      "admin": {
        "activity": {
          "title": "Paramètres d'activité"
        },
        "adminMaterialLists": {
          "title": "Listes de matériel"
        },
        "collaborators": {
          "email": "Adresse e-mail",
          "inactiveCollaborators": "Inactif",
          "members": "Membres",
          "openInvitations": "Invitations ouvertes",
          "title": "Equipe"
        },
        "info": {
          "title": "Infos sur le camp"
        },
        "print": {
          "title": "Imprimer le camp"
        },
        "sideBarAdmin": {
          "itemActivity": "Activités",
          "itemActivitySubtitle": "Catégorie, modèles et statut",
          "itemCollaborators": "Equipe",
          "itemInfos": "Infos sur le camp",
          "itemMaterialLists": "Listes de matériel",
          "itemPrint": "PDF / Imprimer"
        },
        "title": "Admin"
      },
      "campProgram": {
        "reminderLockedCreate": "Glisser pour créer n'est possible qu'en mode déverrouillé.",
        "reminderLockedMove": "Glisser pour déplacer n'est possible qu'en mode déverrouillé.",
        "title": "Programme général"
      },
      "category": {
        "category": {
          "clipboardInfoDialog": {
            "allow": "Autoriser maintenant",
            "denied": "Tu as refusé l'accès à ton presse-papiers. Par conséquent, tu ne peux pas coller les catégories copiées.",
            "description": "Pour coller une catégorie copiée, vous devez autoriser eCamp v3 à lire votre presse-papiers.",
            "granted": "Tu peux maintenant coller les catégories copiées.",
            "title": "Copier et coller la catégorie"
          },
          "copyCategory": "Copier la catégorie",
          "deleteCategory": "Supprimer la catégorie",
          "properties": "Propriétés",
          "template": "Modèle pour les nouvelles activités"
        },
        "sideBarCategory": {
          "title": "Catégories"
        }
      },
      "checklistOverview": {
        "checklistLists": {
          "title": "Vue d'ensemble de la check-list"
        }
      },
      "dashboard": {
        "activities": "Activités",
        "columns": {
          "category": "Catégorie",
          "number": "Numéro",
          "responsible": "Responsable",
          "time": "Temps",
          "title": "Titre"
        },
        "noEntries": "Aucune activité trouvée. Essaie d'effacer les filtres de sélection et/ou de recharger la page.",
        "today": "Aujourd'hui",
        "welcome": "Bienvenue dans ton nouveau camp. Il n'y a pas encore d'activités définies."
      },
      "hitobitoInvite": {
        "allInvited": "Toutes les personnes co-responsables de {provider} ont déjà été invitées.",
        "errors": {
          "invite": "Les invitations n’ont pas pu être envoyées : {emails}",
          "loading": "Les personnes co-responsables n’ont pas pu être chargées. Réessaie plus tard.",
          "noAccess": "Tu n’as pas accès à cet événement {provider}.",
          "notFound": "Cet événement {provider} n’a pas été trouvé."
        },
        "existingParticipants": "Déjà invitées ou membres du camp",
        "intro": "Les personnes co-responsables suivantes ont été trouvées dans l’événement {provider} :",
        "invite": "Envoyer l’invitation | Envoyer {count} invitations",
        "newParticipants": "Personnes qui seront invitées",
        "title": "Inviter depuis {provider}"
      },
      "hitobitoSync": {
        "errors": {
          "forbidden": "Tu n’as pas les autorisations nécessaires pour modifier ce camp.",
          "loading": "Les données de {provider} n’ont pas pu être chargées. Réessaie plus tard.",
          "noAccess": "Tu n’as pas accès à cet événement {provider}.",
          "notFound": "Cet événement {provider} n’a pas été trouvé.",
          "sync": "Les données n’ont pas pu être synchronisées. Réessaie plus tard."
        },
        "intro": "Les champs suivants ont été modifiés dans {provider} et seront écrasés lors de la synchronisation :",
        "noChanges": "Aucune donnée n’a changé depuis la dernière synchronisation.",
        "sync": "Synchroniser",
        "title": "Synchroniser le camp avec {provider}"
      },
      "invitation": {
        "acceptCurrentAuth": "Accepter l'invitation avec le compte courant",
        "backToHome": "Retour à l'accueil",
        "error": "Une erreur inattendue s'est produite",
        "notFound": "Cette invitation est déjà acceptée ou supprimée",
        "openCamp": "Camp ouvert",
        "register": "S'enregistrer",
        "reject": "Refuser l'invitation",
        "successfullyRejected": "L'invitation a été rejetée avec succès",
        "title": "Invitation",
        "useOtherAuth": "Déconnecte-toi et utilise un autre compte",
        "userAlreadyInCamp": "Tu participes déjà à ce camp"
      },
      "material": {
        "materialLists": {
          "title": "Listes de matériel"
        },
        "materialOverview": {
          "createNewList": "Créer une liste de matériel",
          "download": "Télécharger l'aperçu",
          "title": "Aperçu général"
        },
        "materialUnassigned": {
          "excelTitle": "non-assigné",
          "title": "Matériel non-assigné"
        },
        "sideBarMaterialLists": {
          "title": "Listes de matériel"
        }
      },
      "navigation": {
        "desktop": {
          "navTopbar": {
            "campIsLoading": "Le camp est en cours de chargement",
            "material": "Matériel",
            "program": "Programme",
            "story": "Histoire",
            "checklist": "Check-list"
          }
        },
        "mobile": {
          "navBottombar": {
            "material": "Matériel",
            "more": "Plus",
            "program": "Programme",
            "story": "Histoire"
          },
          "navSidebar": {
            "itemActivity": "Activités",
            "itemActivitySubtitle": "Catégorie, modèle & statut",
            "itemCamps": "Mes Camps",
            "itemChecklists": "Vue d'ensemble de la check-list",
            "itemClose": "Fermer le menu",
            "itemCollaborators": "Team",
            "itemInfos": "Infos sur le camp",
            "itemMaterialLists": "Liste de matériel",
            "itemPrinting": "PDF / Imprimer"
          }
        }
      },
      "story": {
        "title": "Histoire"
      }
    },
    "campCreate": {
      "title": "Créer un camp"
    },
    "campHitobitoDeepLink": {
      "errors": {
        "campForbidden": "Cet entrepôt a déjà été importé, mais tu n'y as pas accès. Veuillez contacter l'administrateur de l'entrepôt.",
        "eventForbidden": "Tu n'as pas les droits nécessaires pour importer ce stock.",
        "generic": "Le camp n'a pas pu être ouvert. Réessaie plus tard."
      },
      "title": "Ouvrir le camp"
    },
    "campImport": {
      "title": "Importer un camp depuis {provider}"
    },
    "camps": {
      "create": "Créer un camp",
      "import": "Importer un camp",
      "pastCamps": "Anciens camps",
      "prototypeCamps": "Prototypes",
      "title": "Mes camps"
    },
    "invitations": {
      "personalInvitations": "Invitations"
    },
    "pageNotFound": {
      "backToHome": "Retour à l'accueil",
      "detail": "Hop là ! Tu t'es égaré...{br}Ce lien ne fonctionne malheureusement pas."
    },
    "profile": {
      "profile": "Profil",
      "password": "Mot de passe"
    }
  }
}
